import React from "react";
import ReactHelmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import Home from "./Home";
import AddEmail from "./AddEmail";
import "./App.css";

function App() {
  const { t, i18n } = useTranslation();

  const renderLanguage = (lang, title) =>
    lang !== i18n.language && (
      <button
        className="btn btn-link"
        onClick={() => {
          i18n.changeLanguage(lang);
        }}
      >
        {title}
      </button>
    );

  const renderBack = () => (
    <Link to="/" className="d-block mb-3">
      <i className="fas fa-angle-left mr-1" aria-hidden="true" />
      {t("home")}
    </Link>
  );

  return (
    <>
      <ReactHelmet htmlAttributes={{ lang: i18n.language }}>
        <title>{t("bot_title")}</title>
        <meta name="description" content={t("check_status_for_free")} />
      </ReactHelmet>
      <div className="container py-4">
        <div className="mb-4">
          <h2>{t("bot_title")}</h2>
          <hr />
        </div>
        <Router>
          <Switch>
            <Route path="/email">
              {renderBack()}
              <AddEmail />
            </Route>
            <Route path="/pending">
              {renderBack()}
              <p>{t("pending")}</p>
            </Route>
            <Route path="/success">
              {renderBack()}
              <p>{t("success")}</p>
            </Route>
            <Route path="/unsubscribed">
              {renderBack()}
              <p>{t("unsubscribed")}</p>
            </Route>
            <Route path="/">
              <Home />
            </Route>
          </Switch>
        </Router>
        <div className="mb-4">
          <hr />
          <div className="d-flex justify-space-between">
            <div>
              {renderLanguage("bg", "български")}
              {renderLanguage("en", "english")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
